import { useState, useEffect } from "react";

export default function StickyCallButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href="tel:8178324968"
      className={`fixed bottom-8 right-6 z-50 flex items-center gap-2.5 bg-[#E8500A] hover:bg-[#d14508] text-white font-bold py-3.5 pl-4 pr-5 rounded-full shadow-lg transition-all duration-300 whitespace-nowrap cursor-pointer ${
        visible ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-4 scale-95 pointer-events-none"
      }`}
      aria-label="Call Jerry's Plumbing now — (817) 832-4968"
    >
      <span className="relative w-5 h-5 flex items-center justify-center flex-shrink-0">
        <span className="absolute inset-0 bg-white/30 rounded-full animate-ping" />
        <i className="ri-phone-fill text-sm relative z-10" />
      </span>
      <span className="text-sm hidden sm:inline">(817) 832-4968</span>
    </a>
  );
}
